/** @format */
import { CategoryTileProps } from '../category-tile';

export enum CategoryBlockVariant {
    MIDNIGHT = 'midnight',
    WHITE = 'white',
}

type BaseCategoryBlockProps = {
    tiles: CategoryTileProps[];
    variant?: CategoryBlockVariant;
};

type Loaded<T> = T & {
    isLoading?: false;
};

type Loading<T> = Partial<T> & {
    isLoading: true;
};

export type CategoryBlockProps =
    | Loaded<BaseCategoryBlockProps>
    | Loading<BaseCategoryBlockProps>;

export type StyledCategoryBlockProps = Pick<CategoryBlockProps, 'variant'>;
